import React, { useEffect, useState , useContext } from 'react';
import logo from '../assets/logo.png';
import talking from '../assets/Group 24.svg';
import avatars from '../assets/Group 21444.svg';
import chats from '../assets/Group 21459.svg';
import streaming from '../assets/Group 21458.svg';
import generator from '../assets/Group 21449.svg';
import { decodeJWT, UpdateUserLimits, decodeJWTAndDecryptSub } from '../Firebase';
import NavbarBottom from '../components/NavbarBottom';
import '../App.css';

export default function Home() {


    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('');

    const [pageLoader , setPageLoader] = useState(false)



    useEffect(() => {
        

        const initialize = async () => {
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const token = urlParams.get('jwt_token');
            const sessionToken = sessionStorage.getItem('sessionToken');
    
            if (!token) {
                if (!sessionToken) {
                    setAlertMessage('You don\'t have permission to access this service');
                    setAlertType('danger');
                    setIsAlertOpen(true);
                    setIsAuthorized(false);
                } else {
                    setIsAuthorized(true);
                }
            } else {
                if (!sessionToken) {
                    setPageLoader(true)
                    sessionStorage.setItem('sessionToken', token);
                    await decodeJWTAndDecryptSub(token);
                    setIsAuthorized(true);
                    setPageLoader(false)
                } else {
                    if (sessionToken !== token) {
                        sessionStorage.setItem('sessionToken', token);
                        await decodeJWTAndDecryptSub(token);
                        setPageLoader(false)
                        setIsAuthorized(true);
                    } else {
                        
                        setIsAuthorized(true);
                    }
                }
            }
        };
    
        initialize();
    }, []); // Empty dependency array ensures this runs only once
    

    const closeAlert = () => {
        setIsAlertOpen(false);
    };

    const handleClick = (path) => {
        if (isAuthorized) {
            window.location.href = `/Portal${path}`;
        } else {
            setAlertMessage('You don\'t have permission to perform this action');
            setAlertType('danger');
            setIsAlertOpen(true);
        }
    };

    if(pageLoader){
        return(
            <span className="Spinloader"></span>
        )
    }


    return (
        <>
            <div className="container pt-4" style={{ marginBottom: "15rem" }}>
                <div className="row">
                    <div className="d-flex flex-row  align-items-center gap-2" data-aos="fade-down">
                        <img style={{ borderRadius: '50%', height: '40px' }} src={logo} alt="logo" />
                        <h1 className="bold mb-0">AI Avatar</h1>
                    </div>

                    {isAlertOpen && (
                        <div
                            className={`alert alert-${alertType} alert-dismissible fade show mt-2`}
                            data-aos="fade-right"
                            role="alert"
                        >
                            <h3>{alertMessage}</h3>
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={closeAlert}
                            ></button>
                        </div>
                    )}

                    <div className="grid">
                        <div
                            className={`grid-item grid-item-1`}
                            data-aos="fade-up"
                            onClick={() => handleClick('/talkingphoto')}
                        >
                            <img src={talking} alt="Talking Photo" />
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div>
                                    <h2 className="text-light">Talking Photo</h2>
                                    <p className="mb-0">Create talking photos and generate videos</p>
                                </div>
                                <h2 className="text-light">➜</h2>
                            </div>
                        </div>

                        <div
                            className={`grid-item grid-item-2 `}
                            data-aos="fade-up"
                            onClick={() => handleClick('/avatars')}
                        >
                            <img src={avatars} alt="Avatars" />
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div>
                                    <h2 className="text-light">Avatars</h2>
                                    <p className="mb-0">Generate avatar videos</p>
                                </div>
                                <h2 className="text-light">➜</h2>
                            </div>
                        </div>

                        <div
                            className="grid-item grid-item-3"
                            data-aos="fade-up"
                            onClick={() => handleClick('/streaming')}
                        >
                            <img src={streaming} alt="Streaming Avatars" />
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div>
                                    <h2 className="text-light">Streaming Avatars</h2>
                                    <p className="mb-0">Chat with Ai Avatar</p>
                                </div>
                                <h2 className="text-light">➜</h2>
                            </div>
                        </div>

                        <div
                            className="grid-item grid-item-4"
                            data-aos="fade-up"
                            onClick={() => handleClick('/chat?type=chat')}
                        >
                            <img src={chats} alt="AI Chat" />
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div>
                                    <h2 className="text-light">AI Chat</h2>
                                    <p className="mb-0">Chat with Ai</p>
                                </div>
                                <h2 className="text-light">➜</h2>
                            </div>
                        </div>

                        <div
                            className="grid-item grid-item-5"
                            data-aos="fade-up"
                            onClick={() => handleClick('/chat?type=image')}
                        >
                            <img src={generator} alt="AI Image Generator" />
                            <div className="d-flex flex-row justify-content-between align-items-center w-100">
                                <div>
                                    <h2 className="text-light">AI Image Generator</h2>
                                    <p className="mb-0">Generate images with Ai</p>
                                </div>
                                <h2 className="text-light">➜</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <NavbarBottom auth={isAuthorized} />
        </>
    );
}
